import { DeleteOutlined, PoweroffOutlined } from "@ant-design/icons";
import { Button, message, Modal, Table, Tag } from "antd";
import { ColumnType } from "antd/es/table";
import { useEffect, useState } from "react";
import { IikoRole } from "../../features/integration-setting-table/RolesTable/role.type";
import { useLazyGetIikoRolesQuery, useRemoveIikoRoleMutation, usePatchIikoRoleMutation } from "../../store/api/roleApi";

export const IikoRolePage = () => {
    const [getIikoRoles, { data, isLoading }] = useLazyGetIikoRolesQuery();
    const [removeIikoRole] = useRemoveIikoRoleMutation();
    const [patchIikoRole] = usePatchIikoRoleMutation();
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
    });

    useEffect(() => {
        getIikoRoles({});
    }, []);

    const getColumnSearchProps = (dataIndex: string) => ({
        filterSearch: true,
        onFilter: (value: string, record: any) => record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
        filterMultiple: false,
        filters: data?.data?.map((item: any) => ({
            text: item[dataIndex],
            value: item[dataIndex],
        })) || [],
    });

    const handleDelete = (code: string) => {
        Modal.confirm({
            title: 'Вы уверены, что хотите удалить эту роль?',
            content: 'Это действие нельзя отменить.',
            okText: 'Да',
            okType: 'danger',
            cancelText: 'Нет',
            onOk: async () => {
                try {
                    await removeIikoRole(code).unwrap();
                    message.success('Роль успешно удалена');
                    getIikoRoles({});
                } catch (error) {
                    message.error('Не удалось удалить роль');
                }
            },
        });
    };

    const handleEnable = (code: string) => {
        Modal.confirm({
            title: 'Вы уверены, что хотите включить эту роль?',
            content: 'Роль будет активирована в системе.',
            okText: 'Да',
            okType: 'primary',
            cancelText: 'Нет',
            onOk: async () => {
                try {
                    await patchIikoRole(code).unwrap();
                    message.success('Роль успешно включена');
                    getIikoRoles({});
                } catch (error) {
                    message.error('Не удалось включить роль');
                }
            },
        });
    };

    const columns = [
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
            ...getColumnSearchProps('name'),
        },
        {
            title: 'Код',
            dataIndex: 'code',
            key: 'code',
            ...getColumnSearchProps('code'),
        },
        {
            title: 'Статус',
            dataIndex: 'enabled',
            key: 'enabled',
            render: (enabled: boolean) => (
                <Tag color={enabled ? 'green' : 'red'}>
                    {enabled ? 'Включен' : 'Отключен'}
                </Tag>
            ),
        },
        {
            title: 'Действия',
            key: 'actions',
            render: (_: any, record: IikoRole) => (
                record.enabled ? (
                    <Button
                        icon={<DeleteOutlined />}
                        danger
                        onClick={() => handleDelete(record.code)}
                    />
                ) : (
                    <Button
                        icon={<PoweroffOutlined />}
                        type="primary"
                        onClick={() => handleEnable(record.code)}
                    />
                )
            ),
        },
    ];

    const handleTableChange = (newPagination: any) => {
        setPagination(newPagination);
    };

    return (
        <div>
            <h1>Роли iiko</h1>
            <Table
                bordered
                columns={columns as ColumnType<IikoRole>[]}
                dataSource={data?.data}
                loading={isLoading}
                pagination={pagination}
                onChange={handleTableChange}
                rowKey="id"
            />
        </div>
    );
};
